import React, { Component } from 'react';
import Modal from 'react-responsive-modal';
import { request } from 'graphql-request';
import { compose } from 'react-apollo';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { withRouter } from 'react-router-dom';
import * as actions from '../../../../actions';
import { saveStore } from '../../../../utils';

import Item from './Item';

import { Content, ListItem } from './styles';

class ChangeStore extends Component {
  selectStore = (id) => {
    const query = `
      query {
        storeDataPortal(storeId: "${id}", userId: "${this.props.user.id}") {
          id
          name
          avatarUrl
          status
          roleType
        }
      }
    `;

    request(process.env.REACT_APP_GRAPHQL_ENDPOINT, query)
      .then((res) => {
        saveStore(res.storeDataPortal.id);

        window.location.href = '/dashboard';
      })
      .catch(console.error);
  }

  render() {
    const { open, close } = this.props;

    return (
      <Modal
        open={open}
        onClose={close}
        closeOnEsc={this.props.hasStore}
        closeOnOverlayClick={this.props.hasStore}
        showCloseIcon={this.props.hasStore}
        center
        styles={{ modal: { width: '460px' } }}
      >
        <Content>
          <h2>Escolher loja</h2>
          <ListItem>
            {this.props.user.stores.map(store => (
              <Item
                key={store.id}
                id={store.id}
                item={store}
                onPressItem={this.selectStore}
              />
            ))}
          </ListItem>
        </Content>
      </Modal>
    );
  }
}

const mapStateToProps = state => ({
  user: state.user,
});

const mapDispathToProps = dispatch => bindActionCreators(actions, dispatch);

export default compose(
  connect(mapStateToProps, mapDispathToProps),
  withRouter,
)(ChangeStore);
